import React from "react";

import { getIconPaths, parseIconPaths } from "../../../helpers/IconLibrary";
import { IconProps } from "../../../interfaces/global/icon/IconLibrary";


const Icon = ({ iconName, className = "", color = "black", sizeInPx = "24"}: IconProps) => {
  //certain icons contain a number of paths.
  //each path will require styling applied to it
  const paths = getIconPaths(iconName);
  const pathElements = parseIconPaths((paths as any)?.paths || paths);

  return (
    <div data-testid="thrive-icon" className={`thrive-icon ${className ?? ""}`} >
      <svg xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" viewBox="0 0 80 80" width={`${sizeInPx}px`} height={`${sizeInPx}px`} aria-hidden>
        {pathElements.map((pathElement, index) => (
          <path key={index} d={pathElement} fill={color} />
        ))}
      </svg>
    </div>
  );
};

export default Icon;